import { render, staticRenderFns } from "./veStuAssocActivityApplyShow.vue?vue&type=template&id=daa48328&scoped=true"
import script from "./veStuAssocActivityApplyShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityApplyShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa48328",
  null
  
)

export default component.exports